import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { updatePageSEO, getSiteUrl } from '../../utils/seo';

const allInformation = [
  {
    id: 1,
    date: '2025.01.15',
    category: 'お知らせ',
    title: '春の新作スタイル提案フェア開催のお知らせ',
    description: '2月1日より、春の新作ヘアスタイル提案フェアを開催いたします。最新トレンドを取り入れた春らしいスタイルをご提案させていただきます。カウンセリング時に「春フェア」とお伝えいただくと、トリートメントサービスをプレゼントいたします。',
  },
  {
    id: 2,
    date: '2025.01.08',
    category: 'キャンペーン',
    title: '新規のお客様限定！カット＆トリートメント特別価格',
    description: '初めてご来店いただくお客様を対象に、カット＆トリートメントを特別価格でご提供いたします。この機会にぜひご利用ください。岡山市で美容室をお探しの方、ぜひ当店の技術をお試しください。',
  },
  {
    id: 3,
    date: '2024.12.25',
    category: 'お知らせ',
    title: '年末年始の営業時間のご案内',
    description: '年末年始の営業時間についてお知らせいたします。12月30日まで通常営業、1月1日〜3日は休業、1月4日より通常営業となります。年末のご予約はお早めにお願いいたします。',
  },
  {
    id: 4,
    date: '2024.12.10',
    category: 'イベント',
    title: 'ヘアケア相談会を開催いたします',
    description: '髪のお悩みやヘアケア方法について、専門スタイリストが無料でご相談を承ります。お気軽にご参加ください。岡山市の美容室として、地域の皆様の髪の健康をサポートいたします。',
  },
  {
    id: 5,
    date: '2024.11.28',
    category: 'お知らせ',
    title: '冬の乾燥対策トリートメントメニュー登場',
    description: '冬の乾燥から髪を守る、集中保湿トリートメントメニューが登場しました。髪のパサつきやダメージが気になる方におすすめです。',
  },
  {
    id: 6,
    date: '2024.11.15',
    category: 'キャンペーン',
    title: '紹介キャンペーン実施中',
    description: 'お友達やご家族をご紹介いただくと、紹介者様・被紹介者様ともに次回使える割引クーポンをプレゼントいたします。',
  },
  {
    id: 7,
    date: '2024.11.01',
    category: 'お知らせ',
    title: '新スタッフ加入のお知らせ',
    description: '11月より新しいスタイリストが加わりました。豊富な経験と確かな技術で、お客様の理想のスタイルを実現いたします。',
  },
  {
    id: 8,
    date: '2024.10.20',
    category: 'イベント',
    title: '秋のヘアカラー相談会開催',
    description: '秋にぴったりのヘアカラーをご提案する相談会を開催いたします。トレンドカラーから定番カラーまで、幅広くご相談いただけます。',
  },
];

const categories = ['すべて', 'お知らせ', 'キャンペーン', 'イベント'];

// 営業カレンダーのデータ（2025年2月）
const getCalendarData = () => {
  const year = 2025;
  const month = 1; // 2月（0-indexed）
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  
  // 定休日: 日曜日と祝日
  const holidays = [11, 23, 24]; // 2月の祝日例
  const closedDays: number[] = [];
  
  for (let i = 1; i <= daysInMonth; i++) {
    const dayOfWeek = new Date(year, month, i).getDay();
    if (dayOfWeek === 0 || holidays.includes(i)) {
      closedDays.push(i);
    }
  }
  
  return { year, month: month + 1, firstDay, daysInMonth, closedDays };
};

export default function InformationPage() {
  const [selectedCategory, setSelectedCategory] = useState('すべて');
  const calendarData = getCalendarData();

  useEffect(() => {
    const siteUrl = getSiteUrl();
    updatePageSEO({
      title: 'お知らせ | おかやま美容室 - 岡山市北区の美容室',
      description: '岡山市北区の美容室おかやま美容室からのお知らせ、キャンペーン情報、イベント情報をお届けします。新作スタイル提案フェア、特別価格キャンペーン、ヘアケア相談会など、お得な情報が満載です。',
      keywords: '岡山市 美容室, おかやま美容室, お知らせ, キャンペーン, イベント, ヘアケア相談会',
      canonical: `${siteUrl}/information`,
      ogTitle: 'お知らせ | おかやま美容室 - 岡山市北区の美容室',
      ogDescription: '岡山市北区の美容室おかやま美容室からのお知らせ、キャンペーン情報、イベント情報をお届けします。',
      ogType: 'website',
      ogUrl: `${siteUrl}/information`,
      ogImage: 'https://public.readdy.ai/ai/img_res/a326ea58022b02e25580b6b66ce019c7.jpg',
      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: 'お知らせ',
        description: '岡山市北区の美容室おかやま美容室からのお知らせ、キャンペーン情報、イベント情報',
        url: `${siteUrl}/information`,
        publisher: {
          '@type': 'Organization',
          name: 'おかやま美容室株式会社',
          url: siteUrl,
        },
      },
    });
  }, []);

  const filteredInformation = selectedCategory === 'すべて'
    ? allInformation
    : allInformation.filter(item => item.category === selectedCategory);

  // カレンダーの日付配列を生成
  const generateCalendarDays = () => {
    const days = [];
    // 空白セルを追加
    for (let i = 0; i < calendarData.firstDay; i++) {
      days.push(null);
    }
    // 日付を追加
    for (let i = 1; i <= calendarData.daysInMonth; i++) {
      days.push(i);
    }
    return days;
  };

  const calendarDays = generateCalendarDays();

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative h-96 sm:h-[500px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/e5056d67bdbfc720b47086b7eac117f2.png"
              alt="お知らせ - 岡山市の美容室おかやま美容室"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
          </div>
          <div className="relative z-10 text-center px-4">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-wider" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              INFORMATION
            </h1>
            <p className="text-base sm:text-lg text-white tracking-widest" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              お知らせ
            </p>
          </div>
        </section>

        {/* Information List */}
        <section className="py-16 sm:py-20 lg:py-24 bg-white">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Business Calendar */}
            <div className="mb-12 sm:mb-16">
              <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-center tracking-wider" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                営業カレンダー
              </h2>
              <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg p-4 sm:p-6 shadow-md">
                <div className="text-center mb-3">
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    {calendarData.year}年 {calendarData.month}月
                  </h3>
                </div>
                
                {/* Calendar Grid */}
                <div className="overflow-x-auto">
                  <div className="min-w-[280px] max-w-md mx-auto">
                    {/* Week Days Header */}
                    <div className="grid grid-cols-7 gap-1 mb-1">
                      {['日', '月', '火', '水', '木', '金', '土'].map((day, index) => (
                        <div
                          key={day}
                          className={`text-center text-xs font-semibold py-1 ${
                            index === 0 ? 'text-red-600' : index === 6 ? 'text-blue-600' : 'text-gray-700'
                          }`}
                        >
                          {day}
                        </div>
                      ))}
                    </div>
                    
                    {/* Calendar Days */}
                    <div className="grid grid-cols-7 gap-1">
                      {calendarDays.map((day, index) => {
                        const dayOfWeek = index % 7;
                        const isClosed = day && calendarData.closedDays.includes(day);
                        
                        return (
                          <div
                            key={index}
                            className={`flex items-center justify-center text-xs rounded-md py-1.5 ${
                              !day
                                ? 'bg-transparent'
                                : isClosed
                                ? 'bg-gray-300 text-gray-600 font-semibold'
                                : 'bg-white text-gray-900 font-medium'
                            } ${
                              day && !isClosed ? 'hover:bg-gray-100 transition-colors' : ''
                            }`}
                          >
                            {day && (
                              <div className="text-center">
                                <div className={dayOfWeek === 0 ? 'text-red-600' : dayOfWeek === 6 ? 'text-blue-600' : ''}>
                                  {day}
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                
                {/* Legend */}
                <div className="mt-4 flex flex-wrap gap-4 justify-center text-xs">
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 bg-white rounded border border-gray-300"></div>
                    <span className="text-gray-700">営業日</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 bg-gray-300 rounded"></div>
                    <span className="text-gray-700">定休日</span>
                  </div>
                </div>
                
                <div className="mt-3 text-center text-xs text-gray-600">
                  <p>営業時間: 9:00 - 18:00</p>
                  <p className="mt-0.5">定休日: 日曜日・祝日</p>
                </div>
              </div>
            </div>

            {/* Category Filter */}
            <div className="flex flex-wrap gap-3 justify-center mb-12 sm:mb-16">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-6 py-2 text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    selectedCategory === category
                      ? 'bg-gray-900 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {category}
                </button>
              ))}
            </div>

            {/* Information Items */}
            <div className="space-y-6 sm:space-y-8">
              {filteredInformation.map((item) => (
                <article key={item.id} className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg p-6 sm:p-8 shadow-md hover:shadow-xl transition-all duration-300">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 mb-4">
                    <time className="text-sm text-gray-600 font-medium" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                      {item.date}
                    </time>
                    <span className="px-3 py-1 bg-gray-900 text-white text-xs rounded-full whitespace-nowrap w-fit">
                      {item.category}
                    </span>
                  </div>
                  <h2 className="text-xl sm:text-2xl font-bold mb-4 text-gray-900 leading-snug" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    {item.title}
                  </h2>
                  <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                    {item.description}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
